import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faBuilding,
  faTasks,
  faChartBar,
  faHeadset,
  faSignOutAlt,
  faTv,
  faLink,
  faCog,
  faUserTie,
  faUser,
  faEye,
  faEyeSlash,
  faSignInAlt,
  faBars,
  faTimes,
  faFileDownload,
  faCode,
  faFilter,
  faBan,
  faCheckSquare,
  faFileUpload
} from '@fortawesome/free-solid-svg-icons';

library.add(faBuilding);
library.add(faTasks);
library.add(faChartBar);
library.add(faHeadset);
library.add(faSignOutAlt);
library.add(faTv);
library.add(faLink);
library.add(faCog);
library.add(faUserTie);
library.add(faUser);
library.add(faEye);
library.add(faEyeSlash);
library.add(faSignInAlt);
library.add(faBars);
library.add(faTimes);
library.add(faFileDownload);
library.add(faCode);
library.add(faFilter);
library.add(faBan);
library.add(faCheckSquare);
library.add(faFileUpload);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
Vue.component('font-awesome-icon', FontAwesomeIcon);